import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "inline-block text-left w-full text-gray-500" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-user mr-2" }, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-down" }, null, -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const _hoisted_5 = {
    class: "w-56 origin-top-right right-0 absolute shadow-lg border-gray-100 border-2 rounded-md p-4 mt-2 bg-white",
    style: { "z-index": "1000" }
};
const _hoisted_6 = { class: "py-2 mb-2 border-b-2 border-gray-100" };
const _hoisted_7 = { class: "truncate capitalize" };
const _hoisted_8 = { class: "truncate text-xs" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-home mr-2" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-sign-out-alt mr-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_spinner_modal = _resolveComponent("spinner-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(["flex-row flex hover:bg-gray-100 px-4 py-2 cursor-pointer", {
                        'bg-gray-100': _ctx.dropDownOpen,
                    }]),
                ref: "workSpaceDropdown",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.dropDownOpen = !_ctx.dropDownOpen))
            }, _hoisted_4, 2),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentUser.username), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentUser.email), 1)
                ]),
                (_ctx.canGoToSelection)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.goToSelection())),
                        class: "block text-sm text-primary hover:bg-gray-200 hover:text-gray-900 cursor-pointer p-1"
                    }, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.selection')), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.logout())),
                    class: "block text-sm text-primary hover:bg-gray-200 hover:text-gray-900 cursor-pointer p-1"
                }, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.logout')), 1)
                ])
            ], 512), [
                [_vShow, _ctx.dropDownOpen]
            ])
        ]),
        (_ctx.statusLoginSpinner)
            ? (_openBlock(), _createBlock(_component_spinner_modal, { key: 0 }, {
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('spinner.logout')), 1)
                ]),
                _: 1
            }))
            : _createCommentVNode("", true)
    ], 64));
}
